/* eslint-disable @intercom/intercom/no-bare-strings */

import { isPresent } from '@ember/utils';
export const BLOCK_TYPES = {
  AUDIO_FILE: 'audioFile',
  PARAGRAPH: 'paragraph',
  IMAGE: 'image',
  IMAGE_TEXT: 'imageText',
  INLINE_IMAGE: 'inlineImage',
  ORDERED_LIST: 'orderedList',
  UNORDERED_LIST: 'unorderedList',
  HEADING: 'heading',
  SUBHEADING: 'subheading',
  SUBHEADING3: 'subheading3',
  SUBHEADING4: 'subheading4',
  SMALL: 'small',
  CODE: 'code',
  HTML: 'html',
  VIDEO: 'video',
  VIDEO_FILE: 'videoFile',
  BUTTON: 'button',
  HORIZONTAL_RULE: 'horizontalRule',
  MESSENGER_CARD: 'messengerCard',
  ATTACHMENT_LIST: 'attachmentList',
  SOCIAL: 'social',
  SPACER: 'spacer',
  TABLE: 'table',
  TABLE_CELL: 'tableCell',
  ORDERED_NESTED_LIST: 'orderedNestedList',
  UNORDERED_NESTED_LIST: 'unorderedNestedList',
  IF_ELSE_STATEMENT: 'ifElseStatement',
  CREATE_TICKET_CARD: 'createTicketCard',
  FACEBOOK_LIKE_BUTTON: 'facebookLikeButton',
  TWITTER_FOLLOW_BUTTON: 'twitterFollowButton',
  CALLOUT: 'callout',
  COLLAPSIBLE_SECTION: 'collapsibleSection',
  COLLAPSIBLE_SECTION_SUMMARY: 'collapsibleSectionSummary',
  COLLAPSIBLE_SECTION_CONTENT: 'collapsibleSectionContent',
  UNSUPPORTED_ELEMENT: 'unsupportedElement'
};
export const TEXT_FORMATTER_MARK_OPTIONS = ['bold', 'italic', 'code', 'anchor', 'span'];
export const ALIGNMENTS = {
  left: 'left',
  center: 'center',
  right: 'right',
  justify: 'justify'
};
export const FONT_FAMILIES_DATA = [{
  text: 'Default',
  value: ''
}, {
  text: 'Serif',
  value: 'serif'
}, {
  text: 'Sans Serif',
  value: 'sans-serif'
}, {
  text: 'Monospace',
  value: 'monospace'
}];
export const FONT_FAMILIES = FONT_FAMILIES_DATA.filter(font => isPresent(font.value)).map(font => font.value);
export const DISALLOWED_COLOR_VALUES = ['transparent'];
export const ALIGN_CLASSES = {
  left: 'intercom-interblocks-align-left',
  center: 'intercom-interblocks-align-center',
  right: 'intercom-interblocks-align-right',
  justify: 'intercom-interblocks-align-justify'
};
export const ALIGN_CLASSES_INVERSE = {
  'intercom-interblocks-align-left': 'left',
  'intercom-interblocks-align-center': 'center',
  'intercom-interblocks-align-right': 'right',
  'intercom-interblocks-align-justify': 'justify'
};
export const BLOCK_CLASSES = {
  blockContainer: 'embercom-prosemirror-composer-block-container',
  audio: 'embercom-prosemirror-composer-audio',
  video: 'embercom-prosemirror-composer-video',
  button: 'embercom-prosemirror-composer-button',
  image: 'embercom-prosemirror-composer-image',
  imageText: 'embercom-prosemirror-composer-imagetext',
  table: 'embercom-prosemirror-composer-table intercom-interblocks-table',
  code: 'embercom-prosemirror-composer-code',
  placeholder: 'embercom-prosemirror-composer-placeholder-block',
  social: 'embercom-prosemirror-composer-social',
  spacer: 'embercom-prosemirror-composer-spacer',
  divider: 'embercom-prosemirror-composer-divider',
  callout: 'embercom-prosemirror-composer-callout',
  collapsibleSection: 'embercom-prosemirror-composer-collapsible-section',
  collapsibleSectionContent: 'embercom-prosemirror-composer-collapsible-section-content'
};
export const DEFAULT_ALIGNMENT = ALIGNMENTS.left;
export const HORIZONTAL_RULE_FALLBACK = '___________________________________________________________';
export const MENTION_CLASS = 'entity_mention';
export const NO_MARGIN_CLASS = 'no-margin';
export const BLOCKS_WITH_STYLE = [BLOCK_TYPES.PARAGRAPH, BLOCK_TYPES.HEADING, BLOCK_TYPES.SUBHEADING, BLOCK_TYPES.SUBHEADING3, BLOCK_TYPES.SUBHEADING4, BLOCK_TYPES.SMALL, BLOCK_TYPES.BUTTON, BLOCK_TYPES.ORDERED_LIST, BLOCK_TYPES.UNORDERED_LIST, BLOCK_TYPES.TABLE, BLOCK_TYPES.TABLE_CELL, BLOCK_TYPES.SOCIAL, BLOCK_TYPES.CALLOUT];
export const TEXT_BLOCKS = [BLOCK_TYPES.PARAGRAPH, BLOCK_TYPES.HEADING, BLOCK_TYPES.SUBHEADING, BLOCK_TYPES.SUBHEADING3, BLOCK_TYPES.SUBHEADING4, BLOCK_TYPES.SMALL, BLOCK_TYPES.ORDERED_LIST, BLOCK_TYPES.UNORDERED_LIST];
export const CALLOUT_BLOCK_BACKGROUND_COLORS = {
  blue: '#e3e7fa80',
  green: '#d7efdc80',
  grey: '#e8e8e880',
  red: '#fed9db80',
  yellow: '#feedaf80',
  default: ''
};
export const CALLOUT_BLOCK_BORDER_COLORS = {
  blue: '#334bfa33',
  green: '#1bb15733',
  grey: '#73737633',
  red: '#fd3a5733',
  yellow: '#fbc91633',
  default: '#73737633'
};